<template>
  <div class="dod31">
    <div class="view" id="dod31">
      <div class="view_container">

        <div class="Prallax" id="DOD31">
          <div class="Prallax_item"
          data-parallax
          data-parallax-tweens='[
            {"parent": "DOD31", "start": "100%", "end": "0", "x": [-300, 300], "scale": [3, 0], "breakpoint": "all"}
          ]'></div>
          <div class="Prallax_item"
          data-parallax
          data-parallax-tweens='[
            {"parent": "DOD31", "start": "100%", "end": "-100%", "y": [200, -200], "breakpoint": "all"}
          ]'></div>
          <div class="Prallax_item"
          data-parallax
          data-parallax-tweens='[
            {"parent": "DOD31", "start": "100%", "end": "-100%", "y": [-300, 300], "scale": [1.5, 0.5], "breakpoint": "all"}
          ]'></div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Parallax from '@/modules/day31-parallax-scroll'

export default {
  name: 'Day31',

  data: () => ({
    parallax: false
  }),

  methods: {
    init() {
      console.log('mounted')
      this.parallax = new Parallax({
        targets: [...document.querySelectorAll('#dod31 [data-parallax]')]
      })
    }
  },
  beforeDestroy() {
    if (this.parallax) {
      this.parallax.destroy()
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style scoped lang="scss">
[data-parallax] {
  pointer-events: none;
  transition:
    transform (0.167s * 2) cubic-bezier(0, 0.5, 0.3, 1),
    opacity (0.167s * 2) cubic-bezier(0, 0.5, 0.3, 1);

  .windows & {
    transform: rotate(0.1deg) translateZ(1px);
    transform-origin: 50.01%;
    opacity: 0.01;
  }
}

.Prallax {
  @include FR_FULLSIZE;
}

.Prallax_item {
  @include FR_WH(200px, 'flex');
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -100px;
  margin-left: -100px;
  background-color: red;
  border-radius: 50%;
  &:nth-of-type(2) {
    background-color: blue;
  }
  &:nth-of-type(3) {
    background-color: green;
  }
}

</style>
